import { useState } from "react";
import "./LoginPage.css";
import axiosInstance from "../../lib/axiosInstance";
import { setStoredUser } from "../../lib/permissions";

const API_PREFIX = "/auth";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function apiPost(path, body) {
    try {
      const res = await axiosInstance.post(`${API_PREFIX}${path}`, body);
      return res.data;
    } catch (err) {
      const e = new Error(
        (err.response && err.response.data && err.response.data.error) ||
          (err.response && err.response.statusText) ||
          err.message ||
          "Request failed"
      );
      if (err.response && err.response.status) e.status = err.response.status;
      throw e;
    }
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await apiPost("/login", { email, password });
      const token = data.token;
      if (token) {
        localStorage.setItem("token", token);
        localStorage.setItem("isAuthenticated", "true");
        try {
          const me = await axiosInstance.get("/auth/me");
          const u = me.data?.user ?? me.data;
          if (u) setStoredUser(u);
        } catch {
          if (data.user) setStoredUser(data.user);
        }
        window.location.href = "/dashboard";
      } else {
        throw new Error("No token received");
      }
    } catch (err) {
      if (err && (err.status === 404 || err.status === 401)) {
        setError("Invalid email or password.");
      } else {
        setError(err.message || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="top-bar" />
        <img src="/clinic-logo.png" alt="Clinic logo" className="login-clinic-logo" />
        <h2 className="clinic-name">Dr. Anubbhas</h2>
        <p className="clinic-subtitle">HOMEOPATHY CLINIC & HOSPITAL</p>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="form-error">{error}</div>}
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login to Dashboard →"}
          </button>
        </form>

      </div>

      <p className="footer-text">© 2026 Dr's Homeopathy Clinic. All rights reserved.</p>
    </div>
  );
};

export default LoginPage;
